import React from 'react'
import { Grid } from '@mui/material'

import ColorBox from '../../../../../../../common/Box/ColorWhiteBox'
import mockDataOrder from '../../mockDataOrder'

import OrderDetail from './OrderDetail'
import OrderProgress from './OrderProgress'

const OrderDetailsProgressMain = () => {
  const { MOCK_ORDER_DETAIL, MOCK_ORDER_PROGRESS } = mockDataOrder
  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <ColorBox>
          <OrderDetail {...MOCK_ORDER_DETAIL} />
        </ColorBox>
      </Grid>
      <Grid item xs={12}>
        <ColorBox>
          <OrderProgress {...MOCK_ORDER_PROGRESS} />
        </ColorBox>
      </Grid>
    </Grid>
  )
}

export default OrderDetailsProgressMain
